<template>
    <div v-show="getContactsSchedule" class="contactsSchedule">
        <div class="dt-costumers">
            <div class="col-md-12">
                <h3>Agenda de Contatos</h3>
                <div class="table-responsive">
                    <table id="relLog" ref='tabela' class="table display table-hover table-striped">
                        <thead></thead>
                        <tbody></tbody>
                        <tfoot></tfoot>
                    </table>
                </div>
            </div>
            <component :is="comp" :data="compData" v-on:dismissModal="dismissModal" />
        </div>
    </div>
</template>

<script>
import modalCostumers from '../../costumers/ModalCostumersTOperador.vue';
import { mapGetters } from "vuex";

import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask)

export default {
    components: { modalCostumers },
    props: {
        filter: {
            type: String,
            default: ''
        },
        upList: 0
    },
    data() {
        return {
            dt: null,
            val: this.filter,
            comp: '',
            compData: '',
            contactEquipeOption: '',
            userId: user.getId(),
        }
    },
    watch: {
        getContactsSchedule(newValue) {
            if (newValue) {
                this.createTable();
            }
        },
        upList: function () {
            this.createTable()
        },
        filter: {
            handler: function (val) {
                this.createTable()
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(["getContactsSchedule"]),
    },
    methods: {
        dismissModal() {
            this.comp = '';
            this.createTable();
        },
        formatPhoneNumber(phone) {
            const digits = phone.replace(/\D/g, '');

            if (digits.length === 13) {
                const ddi = digits.slice(0, 2);
                const ddd = digits.slice(2, 4);
                const prefix = digits.slice(4, 9);
                const suffix = digits.slice(9);
                return `+${ddi} (${ddd}) ${prefix}-${suffix}`;
            } else if (digits.length === 12) {
                const ddi = digits.slice(0, 2);
                const ddd = digits.slice(2, 4);
                const prefix = digits.slice(4, 8);
                const suffix = digits.slice(8);
                return `+${ddi} (${ddd}) ${prefix}-${suffix}`;
            }

            return phone;
        },
        async createTable() {
            try {
                if (this.dt) {
                    $('#relLog').DataTable().destroy();
                }

                // 💡 Salva o this do Vue numa variável
                const self = this;

                this.dt = $('#relLog').DataTable({
                    responsive: true,
                    processing: true,
                    serverSide: true,
                    destroy: true,
                    autoWidth: false,

                    dom: 'lBfrtip', 
                    buttons: [
                         {
                            extend: 'excelHtml5',
                            text: '<i class="fa fa-file-excel"></i> Excel',
                            className: 'btn btn-success',
                            exportOptions: {
                                columns: [0,1,2] 
                            }
                        },
                        {
                            extend: 'pdfHtml5',
                            text: '<i class="fa fa-file-pdf"></i> PDF',
                            className: 'btn btn-danger',
                            orientation: 'landscape',
                            pageSize: 'A4',
                            action: function (e, dt, button, config) {

                                const oldLength = dt.page.len();

                                // Solicita todos os registros
                                dt.page.len(-1).draw();

                                // Aguarda carregar todos os dados
                                dt.one('draw', function () {

                                    // Executa exportação
                                    $.fn.dataTable.ext.buttons.pdfHtml5.action.call(this, e, dt, button, config);

                                    // Volta para a paginação anterior
                                    setTimeout(function () {
                                        dt.page.len(oldLength).draw();
                                    }, 500);
                                });
                            }
                        },
                        {
                            text: '<i class="fa fa-sync"></i> Recarregar',
                            className: 'btn btn-primary',
                            action: function (e, dt, node, config) {
                                dt.ajax.reload(null, false);
                            },
                        },
                    ],


                    ajax: {
                        type: "GET",
                        url: '/customer_base/getclients'
                    },
                    columns: [
                        {
                            data: "name",
                            title: "Nome",
                            render: (data, type, row) => {
                                const imageUrl = "/imgs/default-profile.png";
                                return `
                            <div style="display: flex; align-items: center;">
                                <img class="profile-pic" src="${imageUrl}" style="width: 30px; height: 30px; border-radius: 50%; margin-right: 10px;">
                                <span>${data}</span>
                            </div>
                        `;
                            }
                        },
                        {
                            data: "phone",
                            title: "Telefone",
                            className: "text-center",
                            render: (data) => {
                                return self.formatPhoneNumber(data);
                            }
                        },
                        {
                            data: "unique_key",
                            className: "text-center",
                            title: "ID / CPF / CNPJ",
                            render: function (data) {
                                // Verifica se o valor de 'data' é válido antes de formatar
                                if (!data) return "----------";

                                // Formate o CPF inserindo pontos e traço
                                const cpfFormatado = data.replace(
                                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                                    "$1.$2.$3-$4"
                                );

                                return cpfFormatado;
                            },
                        },
                        {
                            data: "id",
                            title: "Detalhes",
                            className: "details-control find-data text-center",
                            render: (data, type, row) => {
                                if (self.userId == 42 ||self.userId == 230 || self.userId == 249 || self.userId == 271) {
                                    return `<button type='button' class='find-data detail-button'>
                                    <i class='find-data fa fa-search-plus'></i>
                                </button>`;
                                }
                                return `<button type='button' class='find-data detail-button' disabled style="opacity: 0.5; cursor: not-allowed;">
        <i class='find-data fa fa-search-plus'></i>
    </button>`;
                            }
                        }
                    ],
                    order: [[0, 'asc']]
                });
            } catch (error) {
                console.error("Erro ao carregar dados de filas: ", error);
            }
        },
    },
    mounted() {
        this.createTable();

        document.querySelector('#relLog tbody').addEventListener('click', (e) => {
            // Encontra o botão com a classe 'detail-button' mais próximo do alvo clicado
            const button = e.target.closest('.detail-button');

            // Se não clicou em um botão ou se o botão está desabilitado, não faz nada
            if (!button || button.disabled) return;

            const tr = button.closest('tr');
            const row = this.dt.row(tr).data();

            this.compData = row;
            this.comp = 'modal-costumers';
        });
    }

}
</script>

<style>
.dt-costumers .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.dt-costumers .modern-table {
    border-collapse: separate;
    border-spacing: 0 8px;
    width: 100%;
}

.dt-costumers .table thead {
    background: linear-gradient(to right, #2c3e50, #34495e);
    color: #ffffff;
    font-weight: 600;
    text-transform: uppercase;
}

.dt-costumers .table tbody tr {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease-in-out;
}

.dt-costumers .table tbody tr:hover {
    background: #f8f9fa;
    transform: scale(1.01);
}

.dt-costumers .table tbody td {
    padding: 12px;
    vertical-align: middle;
    border-top: none;
}

.dt-costumers .profile-pic {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
    border: 1px solid white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 1.2);
    /* Efeito de sombra */
}

.dt-costumers .detail-button {
    background: none;
    border: none;
    font-size: 18px;
    color: #2980b9;
    /* Azul discreto e corporativo */
    transition: color 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.dt-costumers .detail-button:hover {
    color: #1c5985;
    transform: scale(1.15);
}

/* Responsividade */
@media (max-width: 768px) {
    .dt-costumers .table thead {
        font-size: 12px;
    }

    .dt-costumers .table tbody td {
        font-size: 14px;
        padding: 8px;
    }

    .dt-costumers .profile-pic {
        width: 30px;
        height: 30px;
    }
}
</style>